import { Category } from './category/register/category';
import { FormField } from './common/register/form-field';
import { FormFieldHeader } from './common/register/form-field-header/form-field-header';
import { DateField } from './date/register/date';
import { MultiLineInput } from './multi-line-input/register/multi-line-input';
import { PersonField } from './person/register/person';
import { Photo } from './photo/register/photo';
import { Signature } from './signature/register/signature';
import { SignatureArray } from './signature-array/register/signature-array';
import { SignonTableRegisterComponent } from './signon-table/register/signon-table-register.component';
import { Table } from './table/register/table';
import { UserField } from './user/register/user';
import { YesNo } from './yes-no/register/yes-no';

export class FormFieldRegisterFactory {
  private static resolver = {
    category: Category,
    date: DateField,
    person: PersonField,
    photo: Photo,
    signature: Signature,
    signatureArray: SignatureArray,
    table: Table,
    prefilledTable: Table,
    multiLineInput: MultiLineInput,
    signonTable: SignonTableRegisterComponent,
    user: UserField,
    yesNoCheckbox: YesNo,
  };

  private static defaultField = FormField;

  static getFormField(item, header: FormFieldHeader, metadata: Record<string, string>): FormField {
    const Field = this.resolver[header.kind] || this.defaultField;
    return new Field(item, header, metadata);
  }
}
